
<template>
    <div>
        <div class="con-form">
            <vs-row style="align-items: center;">
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Institución <i class="fas fa-shield-alt oblig"></i>
                        </label>
                        <vs-select class="pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length">
                            <template #message-danger v-if="errorFields.includes('institucion')">
                                Requerido
                            </template>
                            <template v-if="instituciones.length" autocomplete="off">
                                <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <div class="control" style="display: inline-flex; align-items: center; padding-left: 10px;">
                        <input ref="excel" class="file" id="file" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="getCambio()" />
                        <label for="file">Seleccionar Archivo</label>
                        <span id="nombreArchivoDocentes" class="ml-2">Archivo</span>
                    </div>
                </vs-col>
            </vs-row>
            <vs-row class="my-4" v-if="excelInfo[0]">
                <vs-col v-if="excelInfo.length > 15">
                    <vs-button
                        success
                        @click="subirExcel == false ? postCrearMasivo() : postSubirExcel()"
                        class="ml-auto"
                        :disabled="desbloqueoBoton()"
                    >
                        {{subirExcel == false ? 'Guardar' : 'Subir excel'}}
                    </vs-button>
                </vs-col>
                <vs-col>
                    <h5>¿Esta seguro de subir la siguiente información?</h5>
                </vs-col>
                <vs-col style="overflow: auto">
                    <template>
                        <div class="center examplex">
                        <vs-table striped v-dragscroll="{ target: '.vs-table', active: true }">
                            <template #thead>
                            <vs-tr>
                                <vs-th>
                                    Apellido paterno
                                </vs-th>
                                <vs-th>
                                    Apellido materno
                                </vs-th>
                                <vs-th>
                                    Nombre(s)
                                </vs-th>
                                <vs-th>
                                    CURP
                                </vs-th>
                                <vs-th>
                                    Sexo
                                </vs-th>
                                <vs-th>
                                    Fecha de nacimiento
                                </vs-th>
                                <vs-th>
                                    Correo
                                </vs-th>
                                <vs-th>
                                    Celular
                                </vs-th>
                                <vs-th>
                                    Teléfono
                                </vs-th>
                                <vs-th>
                                    Extensión
                                </vs-th>
                            </vs-tr>
                            </template>
                            <template #tbody>
                            <vs-tr
                                :key="i"
                                v-for="(tr, i) in excelInfo"
                                :data="tr"
                            >
                                <vs-td>
                                    <p :style="tr.apellido_paterno == '' || tr.apellido_paterno == null ? 'color: red;' : ''">{{ tr.apellido_paterno == '' || tr.apellido_paterno == null ? 'Campo requerido' : tr.apellido_paterno }}</p>
                                </vs-td>
                                <vs-td>
                                    <p :style="tr.apellido_materno == '' || tr.apellido_materno == null ? 'color: red;' : ''">{{ tr.apellido_materno == '' || tr.apellido_materno == null  ? 'Campo requerido' : tr.apellido_materno }}</p>
                                </vs-td>
                                <vs-td>
                                    <p :style="tr.nombres == '' || tr.nombres == null ? 'color: red;' : ''">{{ tr.nombres == '' || tr.nombres == null ? 'Campo requerido' : tr.nombres }}</p>
                                </vs-td>
                                <vs-td>
                                    <p :style="tr.curp == '' || tr.curp == null ? 'color: red;' : ''">{{ tr.curp == '' || tr.curp == null ? 'Campo requerido' : tr.curp }}</p>
                                </vs-td>
                                <vs-td>
                                    <p>{{ tr.sexo }}</p>
                                </vs-td>
                                <vs-td>
                                    <p :style="tr.fecha_nacimiento == '' || tr.fecha_nacimiento == null ? 'color: red;' : ''">{{ tr.fecha_nacimiento == '' || tr.fecha_nacimiento == null ? 'Campo requerido' : tr.fecha_nacimiento}}</p>
                                </vs-td>
                                <vs-td>
                                    <p :style="tr.correo == '' || tr.correo == null ? 'color: red;' : ''">{{ tr.correo == '' || tr.correo == null ? 'Campo requerido' : tr.correo }}</p>
                                </vs-td>
                                <vs-td>
                                    <p :style="tr.celular == '' || tr.celular == null ? 'color: red;' : ''">{{ tr.celular == '' || tr.celular == null ? 'Campo requerido' : tr.celular}}</p>
                                </vs-td>
                                <vs-td>
                                    <p>{{ tr.telefono }}</p>
                                </vs-td>
                                <vs-td>
                                    <p>{{ tr.extension }}</p>
                                </vs-td>
                            </vs-tr>
                            </template>
                        </vs-table>
                        </div>
                    </template>
                </vs-col>
            </vs-row>
        </div>
        <div class="footer-dialog">
            <vs-row>
                <vs-col sm="6" lg="6">
                <vs-button
                    danger
                    flat
                    @click="borrarDatos()"
                >
                    Cancelar
                </vs-button>
                </vs-col>
                <vs-col sm="6" lg="6">
                    <vs-button
                        success
                        @click="subirExcel == false ? postCrearMasivo() : postSubirExcel()"
                        class="ml-auto"
                        :disabled="desbloqueoBoton()"
                    >
                        {{subirExcel == false ? 'Guardar' : 'Subir excel'}}
                    </vs-button>
                </vs-col>
            </vs-row>
        </div>
    </div>
</template>
<script>
import { dragscroll } from 'vue-dragscroll'
import academico from '../../../../../api/requests/academico.js'
export default {
    props:[
        'value',
        'instituciones',
        'aumentarMasi'
    ],
    data:() => ({
        active: false,
        institucion: '',
        institucionD: '',
        institucionId: (new Date()).getTime(),
        masivo: '',
        excelInfo: [],
        errorFields: [],
        campoRequerido: false,
        subirExcel: true
    }),
    mounted(){
        $('#file').change(function(e) {
        var filename = e.target.files[0].name
        $('#nombreArchivoDocentes').html(filename);
        })
    },
    directives: {
       'dragscroll': dragscroll
    },
    methods:{
        sanityForm () {
            this.errorFields = []
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return false
            }
        },
        async postSubirExcel(){
            if(this.sanityForm() == true){
                const loading = this.$vs.loading()
                try {
                    this.subirExcel = false
                    const archivo = this.$refs.excel.files[0]
                    const formData = new FormData()
                    formData.append('upload_docentes', archivo)
                    const {data : response} = await academico.postSubirExcel(this.institucion, formData)
                    loading.close()
                    this.excelInfo = response
                    this.camposReq(response)
                }
                catch(e){
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Hubo un problema',
                        text: 'Por favor, contacte al administrador.'
                    })

                }
            }
        },
        camposReq(info){
            info.forEach(element => {
                if(element.apellido_materno == '' || element.apellido_materno == null){
                    this.campoRequerido = true
                }else if(element.apellido_paterno == '' || element.apellido_paterno == null){
                    this.campoRequerido = true
                }else if(element.nombres == '' || element.nombres == null){
                    this.campoRequerido = true
                }else if(element.celular == '' || element.celular == null){
                    this.campoRequerido = true
                }else if(element.fecha_nacimiento == '' || element.fecha_nacimiento == null){
                    this.campoRequerido = true
                }else if(element.curp == '' || element.curp == null){
                    this.campoRequerido = true
                }else if(element.correo == '' || element.correo == null){
                    this.campoRequerido = true
                }else if(element.apellido_materno && element.apellido_paterno && element.nombres && element.celular && element.fecha_nacimiento && element.curp && element.correo){
                    this.campoRequerido = false
                }
            })
        },
        async postCrearMasivo(){
            const loading = this.$vs.loading()
            try {
                const {data : response} = await academico.postCrearMasivo(this.institucion, this.excelInfo)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa',
                    text: 'Se ha guardado correctamente la información.'
                })
                this.$emit('cerrarModal', 'recargar')
                loading.close()
            }
            catch(error){
                
                const response = error.response.data
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Hubo un problema',
                    text: response.message ? response.message : 'Por favor, contacte al administrador.'
                })

            }
        },
        borrarDatos(){
            this.institucion = ''
            this.excelInfo = []
            this.$emit('cerrarModal')
        },
        getCambio(){
            this.subirExcel = true
        },
        desbloqueoBoton(){
            if(this.subirExcel == true){
                return false
            }
            if(this.subirExcel == false && this.campoRequerido == true ){
                return true
            }
        }
    },
    watch:{
        aumentarMasi(){
            this.borrarDatos()
        },
    }
}
</script>

<style lang="scss" scoped>
.control{
  .file{
    display:none;
    
    color:white;
    & + label{
      font-size:12px;
      color:#fff;
      background:#154360;
      text-align:center;
      vertical-align: text-top;
      padding:5px 8px;
      border:0px solid darken(#154360,30%);
      border-radius: 7px;
      transition:.2s all;
      &:hover{
        cursor:pointer;
        color:darken(#fff,20%);
      }
      & span{
        font-size:12px;
        position:absolute;
        top:60px;
        width:250px;
        text-align:center;
        left:0;
        // background:#fff;
        color:#fff;
      }
    }
  }
}
</style>